<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Mensagens</h5>
                <hr>
				
				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Nova" class="p-mr-2" @click="exibirDialogCadastro=true" v-if="permissaoNovo"/>												
					</template>
				</Toolbar>

				<DataTable :value="mensagens"   :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="titulo" header="Título" sortable></Column>
					<Column field="dataCadastro" header="Cadastro" sortable>						
						<template #body="slotProps">
							{{ formatarDataInput(slotProps.data.dataCadastro, true) }}
						</template>
					</Column>
                    <Column field="dataAtualizacao" header="Atualização" sortable>
						<template #body="slotProps">
							{{ formatarDataInput(slotProps.data.dataAtualizacao, true) }}
						</template>
					</Column>				
					<Column field="dataPublicacao" header="Publicação" sortable>
						<template #body="slotProps">
							{{ formatarDataInput(slotProps.data.dataPublicacao, false) }}
						</template>
					</Column>										
					<Column  header="">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" 
                                class="p-button-rounded p-button-primary p-mr-2" 
                                @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                            <Button icon="pi pi-trash" title="Excluir" 
                                class="p-button-rounded p-button-danger" 
                                @click="confirmarExcluir(slotProps.data)" v-if="permissaoEditar"/>							
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
		<Dialog :visible.sync="exibirDialogCadastro" header="Mensagem" :modal="true" :style="{width: '60vw'}" @hide="limpar">
			<TabView @tab-change="visualizar">
				<TabPanel header="Texto">
					<div class="p-fluid p-formgrid p-grid">                      
						<div class="p-field p-col-12 p-md-10">
							<label for="codigoCliente">Título</label>
							<InputText v-model.trim="titulo"/>
						</div> 
						<div class="p-field p-col-12 p-md-2">
							<label>Publicação</label>
							<Calendar v-model="dataPublicacao" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body"/>
						</div> 
						<div class="p-field p-col-12 p-md-12">
							<label for="codigoCliente">Conteúdo</label>
							<Editor v-model="texto" editorStyle="height: 150px" ref="editorItem">
								<template #toolbar>
									<span class="ql-formats">
										<button class="ql-bold"></button>
										<button class="ql-italic"></button>
										<button class="ql-underline"></button>
										<button class="ql-list" value="ordered"></button>
										<button class="ql-list" value="bullet"></button>
									</span>
								</template>	
							</Editor>
						</div> 
					</div>   
				</TabPanel>
				<TabPanel header="Html" style="font-size: 15px;">
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-col-12 p-md-12" v-html="textoVisualizar"></div>
					</div>
				</TabPanel>
			</TabView>	
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="limpar"/>
				<Button label="Salvar" icon="pi pi-check" @click="validarSalvar"/>
			</template>		
		</Dialog>
		<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
			<div class="confirmation-content" v-if="mensagemExcluir">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Excluir mensagem <b>{{ mensagemExcluir.titulo }}</b>?</span>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
			</template>
		</Dialog>  
	</div>
</template>

<script>
import MensagemService from '@/service/MensagemService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	mensagemService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,		
			exibirDialogConfirmarExcluir: false,	
			exibirDialogCadastro: false,				
            mensagens: [],
            texto: '',		
			classQtdCaracteres: '',
			textoVisualizar: '',
			dataPublicacao: new Date(),
			titulo: '',
			idMensagem: null,
			mensagemExcluir: null,
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getPermissoes']),	
		/**
		 * 
		 */
        validarSalvar() {
			if(!this.texto.trim() || !this.titulo) {
				exibirMensagemSis(this, 'Informe o título e o conteúdo da mensagem', true);
				return;
			}			
			let mensagem = {
				titulo: this.titulo,
				conteudo: this.texto.trim(),
				dataPublicacao: this.formatarData(this.dataPublicacao, false)
			};
			if(!this.idMensagem) {
				this.salvar(mensagem);
			} else {
				this.atualizar(mensagem);
			}
        },
		/**
		 * 
		 */
		salvar(mensagem) {
			this.mensagemService.salvar(mensagem)
			.then(resp => {			
				exibirMensagemSis(this, 'Sucesso', false);	
				this.limpar();
				this.listarTodos();		
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		atualizar(mensagem) {
			this.mensagemService.alterar(this.idMensagem, mensagem)
			.then(resp => {			
				exibirMensagemSis(this, 'Sucesso', false);	
				this.limpar();
				this.listarTodos();			
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		excluir() {
			this.mensagemService.excluir(this.mensagemExcluir.id)
			.then(resp => {			
				exibirMensagemSis(this, 'Sucesso', false);	
				this.limpar();
				this.listarTodos();			
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		listarTodos() {
			this.mensagemService.listarTodos()
			.then(resp => {			
				this.mensagens = resp.data;					
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		editar(mensagem) {
			this.idMensagem = mensagem.id;
			this.titulo = mensagem.titulo;
			let strData = mensagem.dataPublicacao.split('-');
			this.dataPublicacao = new Date(Number(strData[0]), Number((strData[1])-1), Number(strData[2]));
			let textoFormatado = mensagem.conteudo;
			textoFormatado = textoFormatado.replace(/@p/g, '<p>');
			textoFormatado = textoFormatado.replace(/@ep/g, '</p>');
			textoFormatado = textoFormatado.replace(/@b/g, '<strong>');
			textoFormatado = textoFormatado.replace(/@eb/g, '</strong>');	
			this.texto = textoFormatado;
			this.quantidadeCarecteres = this.texto.length;			
			this.exibirDialogCadastro = true;
		},
		/**
		 * 
		 */
		confirmarExcluir(mensagem) {
			this.mensagemExcluir = mensagem;
			this.exibirDialogConfirmarExcluir = true;
		},
		/**
		 * 
		 */
		limpar() {
			this.exibirDialogConfirmarExcluir = false;
			this.exibirDialogCadastro = false;
			this.mensagemExcluir = null;
			this.titulo = '';
			this.texto = '';
			this.textoVisualizar = '';
			this.dataPublicacao = new Date();
			this.classQtdCaracteres = '';
			this.quantidadeCarecteres = 0;
			this.idMensagem = null;
		},
		/**
		 * 	
		 */
		formatarDataInput(strDate, comHora) {
            let data = '';
			if(!strDate) {
				return '';
			}
            if(!comHora) {
                let partes = strDate.split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0];
            } else {
				let arrData = strDate.split(' ');
				let partes = arrData[0].split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0]+' '+arrData[1];
            }
            return data;
        },
		/**
		 * 	
		 */
		formatarData(data) {
            if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
        },
		/**
		 * 
		 */	
		visualizar(event) {
			let tab = event.tab.$options.propsData.header; 
			if(tab == 'Html') {
				this.textoVisualizar = '<h2>'+this.titulo+'</h2>';				
				let textoFormatado = this.texto;
				textoFormatado = textoFormatado.replace(/@p/g, '<p>');
				textoFormatado = textoFormatado.replace(/@ep/g, '</p>');
				textoFormatado = textoFormatado.replace(/@b/g, '<strong>');
				textoFormatado = textoFormatado.replace(/@eb/g, '</strong>');				
				this.textoVisualizar += textoFormatado;
			} 
		},				
		/**
		 * 
		 */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(99999);
			this.permissaoEditar = permissoes.includes(99999);				
		}
	},	
	created() {
		this.mensagemService = new MensagemService();		
		this.listarTodos();
	},
	mounted() {	
		this.validarPermissoes();			
	}
}
</script>

<style scoped>
</style>